import { useEffect, useState } from "react";
import { HOST_URL, reqOptions } from "../../assets/js/helpFunction";
import {
  MssgContainer,
  getDate,
  getEstateID,
} from "../../components/partials/utils";
import WithAuth from "../../components/partials/withAuth";
import styled from "styled-components";
import "./admin-access-log.css";

const AccessIcon = ({ name, size = 18 }) => {
  const paths = {
    key: "M21 2 19 4m-7.6 7.6a5 5 0 1 1-7.1 7.1 5 5 0 0 1 7.1-7.1ZM15.5 7.5l2 2L21 6l-2-2-3.5 3.5Z",
    search: "m21 21-4.35-4.35m2.35-5.65a8 8 0 1 1-16 0 8 8 0 0 1 16 0Z",
    enter: "M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4m-5-4 5-5-5-5m5 5H3",
    exit: "M9 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h4m5-4-5-5 5-5m-5 5h12",
    activity: "M3 12h4l2.5-7 5 14 2.5-7h4",
    empty: "M8 11V7a4 4 0 0 1 8 0v4m-9 0h10a2 2 0 0 1 2 2v7H5v-7a2 2 0 0 1 2-2Z",
  };
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d={paths[name]} stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" /></svg>;
};

const Log = () => {
  const [data, setData] = useState({});
  const [logs, setLogs] = useState([]);
  const [mssg, setMssg] = useState({ error: false, mssg: "" });
  const [search, setSearch] = useState("");
  const [activeIndex, setActiveIndex] = useState(1);
  const checkActive = (index) => (activeIndex === index ? "active" : "");

  const closeMssg = () => {
    setMssg({ error: false, mssg: "" });
  };

  useEffect(() => {
    const requestOptions = reqOptions("get", null, true);
    const api = `${HOST_URL()}estate_access_logs/?estate_id=${getEstateID()}`;
    fetch(api, requestOptions)
      .then((res) => res.json())
      .then((data) => {
        setLogs(data.results);
        setData(data);
      })
      .catch((err) => setMssg({ ...mssg, mssg: err.message, error: true }));
  }, []);

  const filterLogs = (index, name) => {
    setActiveIndex(index);
    document
      .querySelectorAll("tab")
      .forEach((item) =>
        item.classList.includes(activeIndex)
          ? item.classList.add("active")
          : item.classList.remove("active")
      );
    if (name != "ALL") {
      setLogs(data.results.filter((item) => item.status == name));
    } else {
      setLogs(data.results);
    }
  };

  const handleSearch = (e) => {
    const { value } = e.target;
    setSearch(value);
    const requestOptions = reqOptions("get", null, true);
    const api = `${HOST_URL()}estate_access_logs/?estate_id=${getEstateID()}${
      value ? `&search=${value}` : ""
    }`;
    fetch(api, requestOptions)
      .then((res) => res.json())
      .then((data) => {
        setLogs(data.results);
        setData(data);
      })
      .catch((err) => setMssg({ ...mssg, mssg: err.message, error: true }));
  };
  return (
    <WithAuth>
      <main className="admin-access-page">
        {mssg.mssg && <MssgContainer mssg={mssg} close={closeMssg} />}

        <header className="admin-access-header">
          <div>
            <p className="admin-access-kicker"><AccessIcon name="key" /> ACCESS CONTROL</p>
            <h1>Access activity</h1>
            <p>Monitor how estate access codes are used by residents and their visitors.</p>
          </div>
          <div className="admin-access-live"><span></span> Live estate log</div>
        </header>

        <section className="admin-access-summary" aria-label="Access activity summary">
          <article><span className="blue"><AccessIcon name="activity" /></span><div><p>Total movements</p><strong>{data?.count ?? data?.results?.length ?? 0}</strong><small>Recorded access events</small></div></article>
          <article><span className="green"><AccessIcon name="enter" /></span><div><p>Entries</p><strong>{data?.results?.filter((item) => item.status === "ENTRY").length || 0}</strong><small>On the current result set</small></div></article>
          <article><span className="orange"><AccessIcon name="exit" /></span><div><p>Exits</p><strong>{data?.results?.filter((item) => item.status === "EXIT").length || 0}</strong><small>On the current result set</small></div></article>
        </section>

        <section className="admin-access-register">
          <div className="admin-access-register-title"><div><h2>Movement register</h2><p>Review resident-issued access and visitor movement history.</p></div></div>
      <HandleSearchAndTab className="admin-access-toolbar">
        <div className="tabs">
          <span
            className={`tab 1 ${checkActive(1)}`}
            onClick={() => filterLogs(1, "ALL")}
          >
            <button>All</button>
          </span>

          <span
            className={`tab 2 ${checkActive(2)}`}
            onClick={() => filterLogs(2, "ENTRY")}
          >
            <button>Entry</button>
          </span>
          <span
            className={`tab 3 ${checkActive(3)}`}
            onClick={() => filterLogs(3, "EXIT")}
          >
            <button>Exit</button>
          </span>
        </div>

        <div className="event-input">
          <div className="search_set">
            <AccessIcon name="search" />
            <input
              className="eventt"
              type="text"
              name="name"
              placeholder="Search resident, visitor or address"
              onChange={handleSearch}
              value={search}
            />
          </div>
        </div>
      </HandleSearchAndTab>
      <div className="scrollable_table admin-access-table-wrap">
        <table>
          <thead>
            <tr>
              <th>Code owner</th>
              <th>Visitor</th>
              <th>Address</th>
              <th>Entry Date & Time</th>
              <th>Exit Date & Time</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            {logs && logs?.length
              ? logs.map((log, index) => (
                  <tr key={index}>
                    <td>
                      <div className="img-avatar">
                        <div className="admin-access-avatar">{log?.estate_user?.user?.first_name?.[0]}{log?.estate_user?.user?.last_name?.[0]}</div>
                        <div className="user-name"><strong>{log?.estate_user?.user?.first_name} {log?.estate_user?.user?.last_name}</strong><span>Resident</span></div>
                      </div>
                    </td>
                    <td>
                      <strong className="admin-access-visitor">{log?.last_name} {log?.first_name}</strong>
                    </td>
                    <td>{log?.address}</td>
                    <td>
                      <div className="date-time">{getDate(log?.from_date)}</div>
                    </td>
                    <td>
                      <div className="date-time">{getDate(log?.to_date)}</div>
                    </td>
                    <td className="resume_data">
                      <p className={log?.status === "ENTRY" ? "entry" : "exit"}><AccessIcon name={log?.status === "ENTRY" ? "enter" : "exit"} size={14} />
                        {log?.status}
                      </p>
                    </td>
                  </tr>
                ))
              : <tr><td colSpan="6"><div className="admin-access-empty"><AccessIcon name="empty" size={25} /><strong>No access activity found</strong><span>Try a different search or movement filter.</span></div></td></tr>}
          </tbody>
        </table>
      </div>
        </section>
      </main>
    </WithAuth>
  );
};

export default Log;

const HandleSearchAndTab = styled.section`
  .container {
    margin-bottom: 20px;
  }
  .normal_tab {
    background: transparent;
  }
  .event-input {
    max-width: 675px;
  }
  @media (min-width: 760px) {
    display: flex;
    justify-content: space-between;
    .event-input {
      display: flex;
      justify-content: space-between;
      //   width: 57%;
      .select_me {
        margin-left: 10px;
        width: auto !important;
      }
      button {
        margin-top: 0;
        height: 45px;
      }
      .event-select {
        width: 20%;
      }
    }
  }
  @media (max-width: 540px) {
    .event-input {
      .event-select {
        display: none;
      }
    }
  }
  .tabs {
    margin: 0;
    margin-bottom: 30px;
    .tab {
      margin: 0;
      height: 45px;
      align-items: center;
      display: flex;
      justify-content: center;
      padding: 0;
      min-width: 100px;

      text-align: center;
      margin-right: 15px;
      border-bottom: 3px solid #c0c0c0;
      button {
        margin: 0;
        padding: 0 !important;
        padding: 10px;
        //styleName: Web/Small Copy;

        font-size: 16px;
        font-weight: 400;
        line-height: 17px;
        letter-spacing: 0em;
        text-align: left;
      }
    }
    .active {
      background: transparent;
      border-bottom: 3px solid #2d4bf3;
      button {
        color: #2d4bf3;
      }
    }
  }
  .normal_tab.add_tape {
    border-bottom: 2px solid yellow;
  }
`;
